import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import {
  BulkFeatureFlagUpdate,
  ProductFeatureSummary,
} from "./owner-feature-flags.models";

@Injectable()
export class OwnerFeatureFlagsService {
  private http = inject(HttpClient);

  getAll(): Observable<ProductFeatureSummary[]> {
    return this.http.get<ProductFeatureSummary[]>("owner/products/features");
  }

  bulk(update: BulkFeatureFlagUpdate): Observable<void> {
    return this.http.post<void>("owner/products/features/bulk", {
      changes: update.changes,
    });
  }
}
